import { useParams } from "react-router";
import CredMgmtForgotPassword from "../../components/CredMgmtForgotPassword/CredMgmtForgotPassword";
import MsForgotPassword from "../../components/MsForgotPassword/MsForgotPassword";

function CredMgmtForgotPasswordPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <>
      <div className={theme} data-testid="theme-name">
        {tenant == "ms1" ? <MsForgotPassword /> : <CredMgmtForgotPassword />}
      </div>
    </>
  );
}

export default CredMgmtForgotPasswordPage;
